import { useEffect, useCallback, useState } from 'react';
import { IS_TYPING_TIMEOUT } from './config';

export function useTypingStatus({
  sendTyping,
  currentUserDrn,
  chatId,
}: {
  sendTyping: (input: { chatId: string; typing: boolean }) => void;
  currentUserDrn: string;
  chatId: string;
}) {
  const [isTyping, setIsTyping] = useState<{ at: Date; status: boolean }>({
    at: new Date(),
    status: false,
  });

  const startTyping = useCallback(() => {
    setIsTyping((_prev) => {
      return {
        at: new Date(),
        status: true,
      };
    });
  }, [isTyping, isTyping.at, isTyping.status]);

  useEffect(() => {
    const now = new Date();

    let canSendTyping = false;
    if (!isTyping.status) {
      canSendTyping = true;
    } else if (now.getTime() - isTyping.at.getTime() > IS_TYPING_TIMEOUT / 1000) {
      canSendTyping = true;
    } else {
      canSendTyping = false;
    }

    if (canSendTyping) {
      // sendTyping({ chatId: chatId, typing: true });
    }
  }, [isTyping]);

  const stopTyping = useCallback(() => {
    setIsTyping({ at: new Date(), status: false });
    // sendTyping({ chatId: chatId, typing: false });
  }, [sendTyping, currentUserDrn, chatId]);

  // reset typing status
  // effectively stopTyping() without sending the typing status
  const resetTyping = useCallback(() => {
    setIsTyping({ at: new Date(), status: false });
  }, []);

  return { startTyping, stopTyping, resetTyping };
}
